import { SidebarMenuItem } from "./SidebarMenuItem";
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub";
import { useAuth } from '../../../../../app/modules/auth/core/Auth'
import { permissions } from '../../../../../app/modules/apps/setting/role/table/columns/_columns'

export const SidebarMenuInventory = () => {
  const { can } = useAuth()
  const inventoryPerms = permissions.filter(({ section }) => section === 'inventory').map(({ value }) => value)
  const assetPerms = permissions.filter(({ section }) => section === 'asset').map(({ value }) => value)
  const canInventory = can(inventoryPerms)
  const canAsset = can(assetPerms)

  if (!canInventory && !canAsset) return null

  return (
    <>
      {canInventory && <SidebarMenuItemWithSub
        to='/inventory'
        icon='package'
        title='คลังสินค้า'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/inventory/dashboard' icon='element-11' fontIcon='bi-app-indicator' title={'Dashboard'} />
        <SidebarMenuItem to='/inventory/list' icon='abstract-26' fontIcon='bi-app-indicator' title={'รายการสินค้า'} />
        <SidebarMenuItem to='/inventory/advices' icon='notification-bing' fontIcon='bi-app-indicator' title={'Advices'} />
        <SidebarMenuItem to='/inventory/transactions' icon='arrows-loop' fontIcon='bi-app-indicator' title={'Transactions'} />
        <SidebarMenuItem to='/inventory/reports' icon='document' fontIcon='bi-app-indicator' title={'รายงาน'} />
        {/*
          แยกออกมาจากกลุ่ม "รายงาน" เพราะใบคุมไม่ใช่รายงาน — สาขากรอกจำนวนจ่ายออก
          ลงไปในนั้น บันทึก แล้วกดตัดจ่ายให้สต็อกขยับจริง มันจึงเป็นเอกสารที่ทำงานทุกวัน ไม่ใช่ของที่เปิดดูเดือนละครั้ง
        */}
        <SidebarMenuItem
          to='/inventory/exam-room-sheet'
          icon='clipboard'
          fontIcon='bi-app-indicator'
          title={'ใบคุมสินค้าห้องตรวจ'}
        />
        <SidebarMenuItem to='/inventory/signatories' icon='profile-user' fontIcon='bi-app-indicator' title={'ตั้งค่าผู้ลงนาม'} />
      </SidebarMenuItemWithSub>}
      
      {canAsset && <SidebarMenuItemWithSub
        to='/asset-management'
        icon='briefcase'
        title='ทรัพย์สิน'
        fontIcon='bi-archive'
      >
        <SidebarMenuItem to='/asset-management/list' icon='abstract-26' fontIcon='bi-app-indicator' title={'ทะเบียนทรัพย์สิน'} />
        <SidebarMenuItem to='/asset-management/transactions' icon='arrows-loop' fontIcon='bi-app-indicator' title={'รายการเคลื่อนไหว'} />
        <SidebarMenuItem to='/asset-management/depreciation' icon='chart-line-down' fontIcon='bi-graph-down' title={'ตารางคำนวณค่าเสื่อม'} />
        <SidebarMenuItem to='/asset-management/land' icon='geolocation' fontIcon='bi-map' title={'ที่ดิน'} />
        <SidebarMenuItem to='/asset-management/fully-depreciated' icon='timer' fontIcon='bi-hourglass-bottom' title={'สินทรัพย์ครบอายุการใช้งาน'} />
        <SidebarMenuItem to='/asset-management/written-off' icon='trash' fontIcon='bi-archive' title={'สินทรัพย์ที่ยกเลิกใช้งาน'} />
      </SidebarMenuItemWithSub>}
    </>
  )
}
